import React from "react";
import "./divs.css"

function Divs(){
    return(
        <>
        <div className="Divscont">
            <section className="down">
            <i class="fa-solid fa-lightbulb"></i>
            <h5>STRATEGY</h5>
            <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur
            </p>

            <a href="#">More</a>

            </section>
            <section>
            <i class="fa-solid fa-square-poll-vertical"></i>
            <h5>RESALTS</h5>
            <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur
            </p>

            <a href="#">More</a>

            </section>
            <section className="down">
            <i class="fa-solid fa-gem"></i>
            <h5>EXPERTISE</h5>
            <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur
            </p>

            <a href="#">More</a>

            </section>
            <section>
            <i class="fa-solid fa-award"></i>
            <h5>AWARDS</h5>
            <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur
            </p>

            <a href="#">More</a>

            </section>
            <section className="down">
            <i class="fa-solid fa-headset"></i>
            <h5>SUPPORT</h5>
            <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur
            </p>

            <a href="#">More</a>

            </section>
        </div>
        </>
    )
}

export default Divs